import React from 'react';
import AlertMessagge from "../../../components/molecules/alertMessagge/alertMessagge";
import Button from '../../../components/atoms/Button/Button';
import './generic-modal-alert.scss';
import LayoutModal from '../../organisms/layoutModal/layout-modal';

const GenericModalAlert = ({ handleAction, icon, title, description, type }) => {
    return (
        <LayoutModal>
            <div className="f-generic-alert-wrapper">
                <span className="f-generic-alert-close" onClick={() => { handleAction(false) }} >X</span>
                <AlertMessagge
                    icon={<img src={icon} alt="icon" />}
                    messagge={title}
                    description={description}
                    type={type}
                    button={<Button type="button" text="ACEPTAR" onClickAction={() => { handleAction(false); }} classname="f-button f-button--primary" />} />
            </div>
        </LayoutModal>)
};

export default GenericModalAlert;